
import type { EventSourceLocation, TriggerPageViewParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';
import { PAGE_VIEV_ENVIRONMENT } from '~~/constants/env';
import { isProduction } from '~~/helpers/env/checkEnvironmentType';

type CallPageViewEventParams = {
  pageCategory?: EventSourceLocation
  pageTitle?: string
}

type UsePageViewEventReturn = {
  callPageViewEvent: (parameters?: CallPageViewEventParams) => void
}

export default function (): UsePageViewEventReturn {

  const { trackPageView } = useGtmEvents();
  const { getCurrentPageType } = usePageEventLocation();
  const { user } = useUserExtended();
  
  // Deduplication guard: track last event to prevent duplicates within a single navigation
  let lastEventKey = '';

  const removeNavigationHook = useRouter().afterEach(() => {

    lastEventKey = '';

  });

  if (getCurrentScope()) {

    onScopeDispose(removeNavigationHook);

  }
  
  const getPageViewEventData = (explicitTitle?: string): TriggerPageViewParameters => {

    const sessionIdCookieString = document.cookie.match(/_ga_(.+?)=(.+?);/)?.[0]?.split('.')?.[2];
    const sessionId = parseInt(sessionIdCookieString || '');
    const { PROD, DEV } = PAGE_VIEV_ENVIRONMENT;
    const environmentType = isProduction() ? PROD : DEV;
    const pageType = getCurrentPageType();
    const pageViewEventData: TriggerPageViewParameters = {
      page: {
        info: {
          name: explicitTitle || document.title,
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer,
          environment: environmentType,
          hostname: window.location.hostname,
          page_category: pageType,
        },
      },
      user: {
        profile: {
          user_id: parseInt(user?.value?.id) || undefined,
          crm_status: 0, // newsletter status of given email (it's 0 because we don't have a way to check it yet),
          session_id: sessionId || undefined, // GA Session ID identifies the session that an event came from (Integer)
        },
      },
    };

    return pageViewEventData;
  
  };

  const callPageViewEvent = (parameters?: CallPageViewEventParams) => {

    const pageViewEventData = getPageViewEventData(parameters?.pageTitle);

    if (parameters?.pageCategory) {

      pageViewEventData.page.info.page_category = parameters.pageCategory;
    
    }
    
    // Deduplication: prevent duplicate events with same path + title in same navigation
    const eventKey = `${pageViewEventData.page.info.path}|${pageViewEventData.page.info.name}`;

    if (eventKey === lastEventKey) {

      return; // Skip duplicate event
    
    }
    lastEventKey = eventKey;
    
    trackPageView(pageViewEventData);
  
  };

  return { callPageViewEvent };

}
